import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  extractSelectedTicketFromState,
  getActionReasons,
  getRefundReasonOptions,
  getSimplrAccountIdOfSelectedTicket,
} from '../../../../../../extractFromState';
import { addEdgeToDecisionTreePath } from '../../../../../../actions/searchActions';
import { AVAILABLE_FIELDS_CONFIG, DTSelectActionReasonView } from '../../DTSelectActionReasonView';
import SelectInputs from '../../Common/SelectInputs/SelectInputs';
import { createLastMileRefund } from '../../../../../../actions/tools/ShopifyActions';

const DTSelectRefundReasonForLastMileNode = () => {
  const dispatch = useDispatch();

  const refundReasonOptions = useSelector(getRefundReasonOptions);
  const actionReasons = useSelector(getActionReasons);
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const selectedTicket = useSelector(extractSelectedTicketFromState);

  const handleNextButtonClick = async () => {
    await dispatch(createLastMileRefund(simplrAccountId, selectedTicket.ticketId, actionReasons?.refundPrimaryReason));
    dispatch(addEdgeToDecisionTreePath('reason_selected'));
  };

  return (
    <DTSelectActionReasonView
      isNextButtonActive={actionReasons?.refundPrimaryReason}
      onNextButtonClick={handleNextButtonClick}
    >
      <SelectInputs
        placeholder="Select refund reason"
        options={refundReasonOptions}
        fields={AVAILABLE_FIELDS_CONFIG.refundPrimaryReason}
      />
    </DTSelectActionReasonView>
  );
};

export default DTSelectRefundReasonForLastMileNode;
